export default __webpack_public_path__ + "static/media/success-participate-icon.b0e5596c.svg";